import React, { useState } from 'react';
import { useNotaire } from "../context/NotaireContext";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import styled from "styled-components";
import CardFicheNotaire from '../components/CardFicheNotaire'
import AllAffaires from '../components/AllAffairesDashboard';
import AllRdvDashboard from '../components/AllRdvDashboard';
import StatsNotaire from '../components/StatsNotaire';
//catalyst tailwind
import { Input } from '../components/catalyst/input'
import { Heading } from '../components/catalyst/heading'



export const ColListeTransac = styled.div`
display:flex;
flex-direction:row;
gap:1rem;
flex-wrap:wrap;
justify-content:start;
@media all and (max-width: 768px) {
}
`;
export const InputLink = styled(Input)`
background-color:#dee2e6;
margin-top:.5rem;
`;



function Dashboard(args) {
    const context = useNotaire();
    const [copyStatus, setCopyStatus] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const onCopyText = () => {
        setCopyStatus(true);
        setTimeout(() => setCopyStatus(false), 1000); // Reset status after 2 seconds
    };

    // copier l'url de la fiche
    const handleCopyClick = () => {

        // This function will be called when the context.user clicks the copy button
        onCopyText(); // Call the copy function
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2500); // Hide the success message after 2.5 seconds
    };



    //check montant abonnement notaire
    // check montant abonnement notaire (tolérant aux valeurs manquantes)
const rawAbonnement = context?.infoEtude?.stripe_abonnement ?? 0;
const montantAbonnement =
  typeof rawAbonnement === 'number'
    ? rawAbonnement
    : (parseFloat(String(rawAbonnement).replace(',', '.').replace(/[^\d.]/g, '')) || 0);




    //console.log("contexr dash", context)
    if (context.user !== null) {
        return (
            <>
                <div className='container'>
                    <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
                        <Heading>👋 Bonjour  {context.user.prenom}</Heading>
                     
                    <div className="flex gap-4">
                        {/**
                         <Link to="/app/nouvelle-affaire"><button class="btn-primary inline-flex" ><PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" /> Nouvelle affaire</button></Link>
                         **/}
                    </div> 
        
                    </div>

                    <div>

                        {/** fiche  notaire */}
                        <div className="mt-5 sm:w-2/3 mx-auto">
                            <h4 className='font-medium mb-4 text-center'>Votre profil est en ligne 🥳</h4>
                            <div className="overflow-hidden">
                                <div className="">

                                    <CardFicheNotaire
                                        fiche={context.infoNotaire.lien_fiche}
                                        nom={context.user.nom}
                                        prenom={context.user.prenom}
                                        use="oui"
                                        adresse={context.infoEtude.adresse}
                                        telephone={context.infoEtude.telephone}
                                        photo={
                                            context.infoNotaire.photo_profil &&
                                                context.infoNotaire.photo_profil.length > 0 &&
                                                context.infoNotaire.photo_profil[0].url
                                                ? context.infoNotaire.photo_profil[0].url
                                                : undefined
                                        }
                                    />
                                    
                                </div>


                            </div>
                        </div>

                        {/** stats notaire */}
                        <div className="mt-5">
                            <h4 className='font-medium'>Vos statistiques</h4>


                            {context !== null &&
                                <StatsNotaire emailNotaire={context.notaireEmail || context.user.email} />
                            }

                        </div>

                        {/** demande de rdv */}
                        <div className="mt-5">
                            <h4 className='font-medium'>Vos rendez-vous à venir</h4>
                                <AllRdvDashboard />

                        </div>
                        

                        {/** affaires */}
                        <div className="mt-5">
                            <h4 className='font-medium'>Vos affaires</h4>


                            {context.immo !== null &&
                                <AllAffaires />
                            }

                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Dashboard;